import { render, staticRenderFns } from "./WebDesigner.vue?vue&type=template&id=747a8b73&scoped=true"
import script from "./WebDesigner.vue?vue&type=script&lang=js"
export * from "./WebDesigner.vue?vue&type=script&lang=js"
import style0 from "./WebDesigner.vue?vue&type=style&index=0&id=747a8b73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747a8b73",
  null
  
)

export default component.exports